import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-empty-template',
    imports: [
        CommonModule,
        TranslateModule
    ],
    templateUrl: './empty-template.component.html',
    styleUrls: ['./empty-template.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EmptyTemplateComponent implements OnInit {
  @Input() text: string;
  constructor() { }

  ngOnInit(): void {
    if (!this.text) {
      this.text = 'GENERAL.NOTHING_TO_DISPLAY';
    }
  }

}
